// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3XS_R","log":"ModalInventoryLogs_log__3peB7","date":"ModalInventoryLogs_date__2Aixi","userName":"ModalInventoryLogs_userName__3CNxX"};